module.exports = __webpack_public_path__ + "static/media/logo-vistta-negativo.0ca378b0.svg";